import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {MeshGeometryProductOperatorPointGeometryMeshGeometryInput} from "#template/nodes/geometry-graph/attribute-set/product-operator/mesh-geometry-product-operator-point-geometry-mesh-geometry-input"
import {MeshGeometryProductOperatorCurveGeometryCurveGeometryInput} from "#template/nodes/geometry-graph/attribute-set/product-operator/mesh-geometry-product-operator-curve-geometry-curve-geometry-input"
import {MeshGeometryProductOperatorCurveGeometryMeshGeometryInput} from "#template/nodes/geometry-graph/attribute-set/product-operator/mesh-geometry-product-operator-curve-geometry-mesh-geometry-input"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {ProductOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-node"
import {GeometryProductOperatorNode} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-node"

export type MeshGeometryProductOperatorParameters = ProductOperatorParameters<
    | MeshGeometryProductOperatorPointGeometryMeshGeometryInput
    | MeshGeometryProductOperatorCurveGeometryCurveGeometryInput
    | MeshGeometryProductOperatorCurveGeometryMeshGeometryInput
>

const definition: TemplateNodeDefinition<MeshGeometryProductOperatorParameters> = {
    nodeClass: "MeshGeometryProductOperator",
    validation: {
        parameters: z.object({
            name: z.string(),
            operator: z.union([
                graphNode(MeshGeometryProductOperatorPointGeometryMeshGeometryInput),
                graphNode(MeshGeometryProductOperatorCurveGeometryCurveGeometryInput),
                graphNode(MeshGeometryProductOperatorCurveGeometryMeshGeometryInput),
            ]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryProductOperator
    extends GeometryProductOperatorNode<
        2,
        | MeshGeometryProductOperatorPointGeometryMeshGeometryInput
        | MeshGeometryProductOperatorCurveGeometryCurveGeometryInput
        | MeshGeometryProductOperatorCurveGeometryMeshGeometryInput
    >
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    public override get availableInputClasses() {
        return [
            MeshGeometryProductOperatorPointGeometryMeshGeometryInput,
            MeshGeometryProductOperatorCurveGeometryCurveGeometryInput,
            MeshGeometryProductOperatorCurveGeometryMeshGeometryInput,
        ]
    }
}
